import { parseDate, formatDateTime, DateTimeFormat, DateTimeFormatParse } from '@occc-app/lib/date';

/**
 * Parses a time string (HH:mm:ss) into a Date object.
 * Uses parseDate from @occc-app/lib/date with Time24hFull format.
 */
export const parseTimeString = (timeString: string | null): Date | null => {
  if (!timeString) return null;
  return parseDate(timeString, DateTimeFormatParse.Time24hFull);
};

/**
 * Formats a Date object to a time string (HH:mm:ss).
 * Uses formatDateTime from @occc-app/lib/date with Time24h format.
 */
export const formatTimeToString = (date: Date | null): string => {
  if (!date) return '';
  return formatDateTime(date, DateTimeFormat.Time24h);
};
